import { Col, Row } from "antd";
import CompositeCard from "@/shared/components/assessment/CompositeCard/CompositeCard";
import AssessmentTemplateCardGridItem from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGridItem";
import AssessmentTemplateCardGrid from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGrid";
import SectionHeader from "@/shared/components/assessment/report/SectionHeader/SectionHeader";
import style from "./style.module.css";
import { InfoCircleFilled } from "@ant-design/icons";
import { IAssessmentComposite } from "@/modules/assessments/hooks/use-get-assessment-composites-by-invite.hook";

interface ITemplateCompositesProps {
  templateComposites: IAssessmentComposite[];
}

export default function TemplateComposites({ templateComposites }: ITemplateCompositesProps) {
  const composites: IAssessmentComposite[] = templateComposites.filter(
    (composite): composite is IAssessmentComposite => !composite.isOverall,
  );

  return (
    <Row className={style.compositesContainer}>
      <Col span={24}>
        <SectionHeader title="Competency Fit" />
        <div className={style.helpText}>
          <InfoCircleFilled className={style.helpIcon} />
          <span>Provides insight into job-specific areas for further exploration, as needed.</span>
        </div>
        <AssessmentTemplateCardGrid>
          {composites.map((composite) => (
            <AssessmentTemplateCardGridItem key={composite.compositeKey} fullWidth>
              <CompositeCard composite={composite} />
            </AssessmentTemplateCardGridItem>
          ))}
        </AssessmentTemplateCardGrid>
      </Col>
    </Row>
  );
}
